import axios from "./axiosService";
import services from "./base";

const taskService = {
  getAllTasks: async () => {
    try {
      const response = await axios.get(`${services.urlTask}/pending`);
      return response.data;
    } catch (error) {
      return error.message;
    }
  },

  getAllTasksDone: async () => {
    try {
      const response = await axios.get(`${services.urlTask}/done`);
      return response.data;
    } catch (error) {
      return error.message;
    }
  },

  createTask: async (obj) => {
    try {
      const response = await axios.post(services.urlTask, { obj });
      if (response.data.error) {
        return response.data.error;
      } else {
        return response.status;
      }
    } catch (error) {
      console.log(error);
      return error.message;
    }
  },

  updateTaskById: async (obj) => {
    try {
      const response = await axios.patch(`${services.urlTask}/task/${obj.id}`, obj);
      return {
        success: true,
        data: response.data,
        message: "Dato actualizado correctamente",
      };
    } catch (error) {
      console.error("Error updating task:", error);
      return {
        success: false,
        data: null,
        message: error?.response?.data?.message || "Error al actualizar el registro",
      };
    }
  },

  updateTaskStateById: async (obj) => {
    try {
      const response = await axios.patch(`${services.urlTask}/state/${obj.id}`, obj);
      return {
        success: true,
        data: response.data,
        message: "Dato actualizado correctamente",
      };
    } catch (error) {
      console.error("Error updating task:", error);
      return {
        success: false,
        data: null,
        message: error?.response?.data?.message || "Error al actualizar el estado",
      };
    }
  },

  deleteTaskById: async (id) => {
    try {
      const response = await axios.delete(services.urlTask + "/" + id, { params: { id } });
      return {
        success: true,
        data: response.data,
        message: "Dato eliminado correctamente",
      };
    } catch (error) {
      console.error("Error deleting task:", error);
      return {
        success: false,
        data: null,
        message: error?.response?.data?.message || "Error al eliminar el registro",
      };
    }
  },
};

export default taskService;
